<template>
  <div>
    <div id="sidebar-wrapper">
      <div class="text-center" id="logo-area">
        <img src="@/assets/images/brand/logo.svg" alt="Urbnx logo" id="logo" />
        <p id="subtitle-logo">SPACE AREA</p>
      </div>
      <SidebarActions />
    </div>
  </div>
</template>

<script>
import SidebarActions from "./components/SidebarActions.vue";

export default {
  components: {
    SidebarActions
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/variables";

#sidebar-wrapper {
  background: $sidebar-color;
  height: 100vh;
  width: $sidebar-width;
  position: fixed;
  top: 0;
  left: 0;

  #logo-area {
    background: #fff;
    padding: 20px;
  }

  #subtitle-logo {
  font-family: $worksans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #000000;
  margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sidebar/Sidebar.vue